import React, { useState, Fragment, useEffect, useRef } from 'react'
import styled from 'styled-components'
import { ReactEditor, useReadOnly, useFocused, useSelected, useSlate } from 'vendor/slate-react'
import { Transforms } from 'vendor/slate'
import { Button, FormControl, FormGroup } from 'react-bootstrap'
import { GraphiQL } from 'graphiql'
import 'graphiql/graphiql.min.css'
import { createGraphiQLFetcher } from '@graphiql/toolkit'

const GraphiqlWrapper = ({ attributes, children, element, editor }) => {
  const { url } = element
  const readOnly = useReadOnly()
  const [urlInputOpen, setUrlInputOpen] = useState(false)
  const [urlValue, setUrlValue] = useState(url)
  const path = ReactEditor.findPath(editor, element)

  const graphQLFetcher = createGraphiQLFetcher({ url })

  return (
    <Wrapper>
      <GraphiqlDisplay contentEditable={false}>
        <GraphiQL fetcher={graphQLFetcher} headerEditorEnabled />
      </GraphiqlDisplay>
      {!readOnly && (
        <GraphiqlControlsAndUrlWrapper contentEditable={false}>
          <GraphiqlControls>
            <GraphiqlControlButton
              variant="secondary"
              size="sm"
              active={urlInputOpen}
              onClick={() => {
                setUrlInputOpen(!urlInputOpen)
              }}
            >
              <i className="fad fa-link" />
            </GraphiqlControlButton>
          </GraphiqlControls>
          <GraphiqlControlsWrapper>
            {urlInputOpen && (
              <GraphiqlUrl>
                <FormGroup className="mb-3">
                  <FormControl
                    size="sm"
                    as="input"
                    placeholder="Enter a graphiql url"
                    value={urlValue || ''}
                    onChange={e => {
                      const { value } = e.target
                      if (value.includes('application/x-slate-clipboard:')) {
                        return
                      }
                      setUrlValue(value)
                    }}
                  />
                </FormGroup>
                <Button
                  size="md"
                  variant={url !== urlValue && urlValue && urlValue.length > 0 ? 'primary' : 'secondary'}
                  disabled={url === urlValue || !urlValue}
                  onClick={() => {
                    Transforms.setNodes(editor, { url: urlValue }, { at: path })
                  }}
                >
                  Save
                </Button>
              </GraphiqlUrl>
            )}
          </GraphiqlControlsWrapper>
        </GraphiqlControlsAndUrlWrapper>
      )}
    </Wrapper>
  )
}
export default GraphiqlWrapper

const Wrapper = styled.div`
  margin: 15px 0px;
  position: relative;
`
const GraphiqlDisplay = styled.div`
  padding: 15px 10px;
  height: 500px;
`
const GraphiqlControlsWrapper = styled.div``

const GraphiqlControlsAndUrlWrapper = styled.div`
  margin: 15px 0px 15px 0px;
  width: 100%;
`

const GraphiqlControls = styled.div`
  justify-content: space-between;
  width: 100%;
  display: flex;
`

const GraphiqlControlButton = styled(Button)`
  color: ${props => props.theme.textGreyTinted}; !important;
  font-size: 11px;
  font-weight: bold;
`

const GraphiqlUrl = styled.div`
  font-size: 16px;
  color: ${props => props.theme.textGreyTintedLighter};
  margin-top: 15px;
  margin-bottom: 10px;
  width: 100%;
  text-align: right;
  input::placeholder {
    color: ${props => props.theme.textGreyTintedLighter};
  }
`
